import React, { useCallback, useEffect, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";
import { get, updateToken } from "../../../../../helpers/api_helper";
import { useDispatch, useSelector } from "react-redux";
import { resetPlanCreated } from "../../../../../store/plan";
import PlanTableData from "../PlanTableData";
import Pagination from "../../../../../components/Pagination";
import { PLANS_LISTING } from "../../../../../helpers/url_helper";

const CreatePlanTab = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.login.token);
  const isPlanCreated = useSelector((state) => state.plan.isPlanCreated);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);

  const fetchPlans = useCallback(
    async (page = 1) => {
      setLoading(true);
      if (token) {
        updateToken(token);
        try {
          const response = await get(
            `${PLANS_LISTING}?page=${page}&limit=${itemsPerPage}`
          );
          if (response?.success) {
            setPlans(response?.data?.items || []);
            setTotalPages(response?.data?.totalPages || 0);
          } else {
            console.log("Failed to fetch plans");
          }
        } catch (error) {
          console.log("An error occurred while fetching plans", error);
        } finally {
          setLoading(false);
        }
      }
    },
    [token, itemsPerPage]
  );

  useEffect(() => {
    if (isPlanCreated) {
      fetchPlans(currentPage);
      dispatch(resetPlanCreated());
    }
    fetchPlans(currentPage);
  }, [isPlanCreated, fetchPlans, currentPage, dispatch]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
      fetchPlans(newPage);
    }
  };

  return (
    <>
      <Row className="scrollable-table-container">
        <Col md="12" className="my-2">
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "200px" }}
            >
              <Spinner animation="border" />
            </div>
          ) : (
            <>
              <PlanTableData planData={plans} setRefresh={fetchPlans} />
              {totalPages > 1 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              )}
            </>
          )}
        </Col>
      </Row>
    </>
  );
};

export default CreatePlanTab;
